export const detectGoalIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete goal" || cleaned === "remove goal") {
        return { intent: "delete_goal" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) goal/);
    if (deleteMatch) {
        return { intent: "delete_goal", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create goal") || cleaned.includes("add goal")) {
        return { intent: "create_goal" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create goal named (.+)/);
    if (createMatch) {
        return { intent: "create_goal", name: createMatch[1].trim() };
    }

    return null;
};
